import { Spinner } from '../../../components/common';
import { useCallSummaryReport } from '../../../hooks/useCallReporting';
import { CallReportFilters } from './common/call-report-constants';

interface CallSummaryProps {
  filters: CallReportFilters;
}

export const CallsSummary: React.FC<CallSummaryProps> = ({ filters }) => {
  const { data: callSummaryReport, isLoading } = useCallSummaryReport(filters);

  return (
    <div className="max-w-4xl p-4">
      <h1 className="mb-4 text-2xl font-bold">Call Summary Report</h1>
      <div className="overflow-x-auto">
        {isLoading ? (
          <Spinner />
        ) : (
          <table className="min-w-full border border-gray-200 bg-white font-mono">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="border-b px-4 py-2">Date</th>
                <th className="border-b px-4 py-2">Calls</th>
                <th className="border-b px-4 py-2">Successful</th>
                <th className="border-b px-4 py-2">Failed</th>
              </tr>
            </thead>
            <tbody>
              {callSummaryReport?.data.map((summary, index) => (
                <tr key={index} className="whitespace-nowrap text-sm hover:bg-gray-50">
                  <td className="w-1/6 border-b px-4 py-2 align-top">{summary.date}</td>
                  <td className="w-1/5 border-b px-4 py-2 align-top">
                    <div className="flex justify-between">
                      <p>Total:</p>
                      <p className="font-bold">{summary.total_calls}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Now:</p>
                      <p className="font-bold">{summary.total_now_calls}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Scheduled:</p>
                      <p className="font-bold">{summary.total_scheduled_calls}</p>
                    </div>
                  </td>
                  <td className="w-1/3 border-b px-4 py-2 align-top">
                    <div className="flex justify-between">
                      <p>Total Successful Calls:</p>
                      <p className="font-bold">{summary.total_successful_calls}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Average Minutes/Call:</p>
                      <p className="font-bold">{summary.successful_call_average_minutes}</p>
                    </div>
                  </td>
                  <td className="w-1/5 border-b px-4 py-2 align-top">
                    <div className="flex justify-between">
                      <p>Total Failures:</p>
                      <p className="font-bold">{summary.total_failed_calls}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Member Failed:</p>
                      <p className="font-bold">{summary.total_member_failed}</p>
                    </div>
                    <div className="flex justify-between">
                      <p>Listener Failed:</p>
                      <p className="font-bold">{summary.total_listener_failed}</p>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
